import { getCategoryDescriptions, getLabelValues, isBuiltInLabelCategory, isBuiltInLabelType, localizeLabelValueCategory, mapLabelValueToListItem, RestLabelValueResponse } from '@tableau/catalog-ui-temp';
import { restApiService } from '@tableau/vizportalclient-common-components';

import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { IListFetcher } from '~src/httpClient/fetchers/IListFetcher';
import { ListResult } from '~src/httpClient/fetchers/ListResult';
import { IPagedItemsParams } from '~src/httpClient/serverApi/types/IPage';

import { ILabelValueInfo } from '../models/ILabelValueInfo';

export class LabelValueResourceFetcher implements IListFetcher<ILabelValueInfo> {
    public fetchList(_params: IPagedItemsParams): Promise<ListResult<ILabelValueInfo>> {
        return getLabelValueLandingPageCall()
        .then((result) => {
            const startIndex = _params.page ? _params.page.startIndex : 0;
            return new ListResult<ILabelValueInfo>(mapLabelValueResultToLabelValueGrid(result), startIndex, result.values.length);
        });
    }
}

type LabelValueLandingPageCall = {
  readonly values: ReadonlyArray<RestLabelValueResponse>;
  readonly categories: Record<string, string>;
}

export async function getLabelValueLandingPageCall(): Promise<LabelValueLandingPageCall>{
    const siteLuid = SessionSiteSelectors.siteLuid(getAppStore().getState());
    const {makeJsonRestApiRequest} = restApiService({siteLuid});
    const categories = await getCategoryDescriptions({ makeJsonRestApiRequest });
    const values = await getLabelValues({ makeJsonRestApiRequest });

    return { categories, values };
}

export function mapLabelValueResultToLabelValueGrid({ values, categories }: LabelValueLandingPageCall): ILabelValueInfo[]{
  return values.map((result, i) => ({
    contentType: 'labelValue',
    id: i.toString(),
    category: result.category,
    localizedCategory:localizeLabelValueCategory(result.category, result.name),
    value: result.name,
    localizedValue: mapLabelValueToListItem(result).content,
    visiblity: result.elevatedDefault,
    labelDescription: result.description,
    builtIn: result.builtIn,
    categoryDescription: categories[result.category],
  } as ILabelValueInfo)).sort(sortLabelValues);
  }

function sortLabelValues(a: ILabelValueInfo, b: ILabelValueInfo): number {
  // sort by 
      // a) whether the label category is built-in
      // b) whether the label type is built-in
      // c) sort category by alphabetical order
      // d) sort type by alphabetical order
      return compareCategory(a.category, b.category)
      || compareType(a.value, b.value)
      || (a.localizedCategory > b.localizedCategory? 1 : (a.localizedCategory < b.localizedCategory? -1 : 0))
      || (a.localizedValue > b.localizedValue ? 1 : -1);
}

function compareCategory(categoryA: string, categoryB: string){
    // built in categories need to be sorted on the top
    return  (isBuiltInLabelCategory(categoryB)? 1 : 0) - (isBuiltInLabelCategory(categoryA)? 1 : 0);
}

function compareType(typeA: string, typeB: string){
    // built in types need to be sorted on the top
    return (isBuiltInLabelType(typeB)? 1 : 0) - (isBuiltInLabelType(typeA)? 1 : 0) ;
}